import { Topic } from '@shapeable/gesda-types';

export const CITATION_PUBLISHER = 'GESDA';
export const CITATION_RADAR_TITLE = 'The GESDA Science Breakthrough Radar';

// Until brief DOIs are minted (~Sep 2025), Topic `doiId` holds a journal URL.
// Restore the block below when the registry supplies real DOI ids.
//
export const normalizeDoiId = (doiId?: string) => (
  (doiId || '').replace(/^https?:\/\/(?:dx\.)?doi\.org\//i, '').trim()
);

export const doiUrlFor = (doiId?: string) => {
  const normalized = normalizeDoiId(doiId);
  return normalized ? `https://doi.org/${normalized}` : '';
};

export const formatTopicCitation = (entity?: Topic) => {
  if (!entity?.name) {
    return '';
  }

  const dateValue = entity.published;
  const year = dateValue ? dateValue.slice(0, 4) : 'n.d.';
  const doiUrl = doiUrlFor(entity.doiId);
  const doiSuffix = doiUrl ? ` ${doiUrl}` : '';

  return `${CITATION_PUBLISHER}. (${year}). ${entity.name}. ${CITATION_RADAR_TITLE}${doiSuffix}`;
};